/**
 * Singleton QueryClient shared across the app.
 *
 * Exported as a module-level constant so non-React code (api-client.ts)
 * can call queryClient.clear() on session changes without going through
 * a hook. App.tsx passes this instance to QueryClientProvider.
 */
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
});
